import { useContext } from 'react';
import PopUp from '../pop-up/pop-up.component';
import { PopUpContext } from '../../contexts/ui.context';

import { 
    // StarOutlined, 
    // StarFilled, 
    // StarTwoTone, 
    WhatsAppOutlined, 
    FacebookOutlined,
    InstagramOutlined,
    TikTokOutlined,
    MediumOutlined,
    PinterestOutlined
} from '@ant-design/icons';

import './social.styles.scss';


const Social = ({icon, title}) => {
	const { setCurrentPopUp } = useContext(PopUpContext);

	// const toMail  = (e) => {
    //     window.location.href = mailto;
    //     e.preventDefault();
    //     // window.prompt("Manually copy the Gmail address below if you are not redirected.", "treegotyou@gmail.com");
    // }

	const goContact = () => {

		switch(title) {
			case 'Medium':
				setCurrentPopUp(<PopUp 
					info="OPENING BLOG IN A NEW TAB" 
					go={() => {
						window.open('https://medium.com/@treegotyou/subscribe');
						setCurrentPopUp(null);
					}}
				/>);
				break;
			case 'Mail':
				window.prompt("Manually copy the Gmail address below if you are not redirected.", "treegotyou@gmail.com");
				break;
			case 'Whatsapp':
				setCurrentPopUp(<PopUp 
					info="Open Whatsapp." 
					go={() => {
						window.open('https://wa.me/qr/3N43HTMZUD4QJ1');
						setCurrentPopUp(null);
					}}
				/>);
				break;
			case 'LinkedIn':
				setCurrentPopUp(<PopUp 
					info="Open linkedin.com in a new tab." 
					go={() => {
						window.open('https://www.linkedin.com/in/eniola-fashola-0543a218b');
						setCurrentPopUp(null);
				}}
				/>);
				break;
			case 'Twitter':
			setCurrentPopUp(<PopUp 
				info="Open twitter.com in a new tab." 
				go={() => {
					window.open('https://twitter.com/place_of_god');
					setCurrentPopUp(null);
				}}
			/>);
				break;
			case 'Messanger':
				setCurrentPopUp(<PopUp 
					info="Messanger not available." 
					go={() => setCurrentPopUp(null)}
				/>);
				break;
			default:
				return 'Woo Jooor';
		}

		
	}


	const openWA = () => {
		setCurrentPopUp(<PopUp 
			info="OPENING WHATSAPP ON A NEW TAB" 
			go={() => {
				window.open('https://wa.me/2348032404351');
				setCurrentPopUp(null);
			}}
		/>);
	}

	const openFB = () => {
		setCurrentPopUp(<PopUp 
			info="OPENING FACEBOOK ON A NEW TAB" 
			go={() => {
				window.open('https://www.facebook.com/treegotyou?mibextid=ZbWKwL');
				setCurrentPopUp(null);
			}}
		/>);
	}

	const openIG = () => {
		setCurrentPopUp(<PopUp 
			info="OPENING INSTAGRAM ON A NEW TAB" 
			go={() => {
				window.open('https://www.instagram.com/treegotyou?igsh=em83djZqYzF1NWJ1');
				setCurrentPopUp(null);
			}}
		/>);
	}

	const openTK = () => {
		setCurrentPopUp(<PopUp 
			info="OPENING TIKTOK ON A NEW TAB" 
			go={() => {
				window.open('https://www.tiktok.com/@treegotyou?_t=8p2pRVA7URx&_r=1');
				setCurrentPopUp(null);
			}}
		/>);
	}

	const openMD = () => {
		setCurrentPopUp(<PopUp 
			info="OPENING MEDIUM ON A NEW TAB" 
			go={() => {
				window.open('https://medium.com/@treegotyou');
				setCurrentPopUp(null);
			}}
		/>);
	}

	const openPI = () => {
		setCurrentPopUp(<PopUp 
			info="OPENING PINTEREST ON A NEW TAB" 
			go={() => {
				window.open('https://pin.it/16IBwRF6k');
				setCurrentPopUp(null);
			}}
		/>);
	}
	
	return(
		<div className='socials-container'>
			<WhatsAppOutlined onClick={openWA} />
			<FacebookOutlined onClick={openFB} />
			<InstagramOutlined onClick={openIG} />
			<TikTokOutlined onClick={openTK} />
			<MediumOutlined onClick={openMD} />
			<PinterestOutlined onClick={openPI} />
		</div>
	);
}

{/* <div className='contact-container' onClick={goContact} >
			{icon}
		</div> */}


export default Social;